module.exports = __webpack_public_path__ + "img/out-pic.5175b4d5.png";